import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";

import AppLayout from "../../components/layout/AppLayout";
import Breadcrumb from "../../components/layout/Breadcrumb";
import TurningOrderForm from "../../components/turningOrders/TurningOrderForm";
import { pageTitleClass } from "../../components/ui/styles";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getLoggingUser } from "../../features/loggingUser/loggingUserSlice";
import {
  clearTurningOrderPartyInfo,
  fetchTurningOrderParties,
  fetchTurningOrderPartyInfo,
  getTurningOrderPartyInfo,
  getTurningOrderPartyInfoLoading,
  getTurningOrderPartyOptions,
} from "../../features/turningOrders/turningOrdersSlice";
import { POST } from "../../services/axios.service";
import { orderLinePayload } from "../../static/cuttingLine";
import { hasPermission, permission } from "../../static/permission";
import { route } from "../../static/route";
import { toastStyles } from "../../static/styles";
import { BreadcrumbType } from "../../types/common";
import { ITurningOrderFormInput } from "../../types/turningOrder";

const breadcrumbItems: BreadcrumbType[] = [
  { label: "હોમ", href: route.dashboard },
  { label: "ટર્નિંગ ઓર્ડર", href: route.turningOrders },
  { label: "નવો ઓર્ડર" },
];

const TurningOrderCreatePage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const partyOptions = useAppSelector(getTurningOrderPartyOptions);
  const partyInfo = useAppSelector(getTurningOrderPartyInfo);
  const partyInfoLoading = useAppSelector(getTurningOrderPartyInfoLoading);
  const loggingUser = useAppSelector(getLoggingUser);

  const withRates = hasPermission(
    loggingUser?.permissions,
    permission.turningRate
  );

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    dispatch(fetchTurningOrderParties());
    dispatch(clearTurningOrderPartyInfo());
  }, [dispatch]);

  const handlePartyChange = useCallback(
    (partyId: number) => {
      if (partyId) {
        dispatch(fetchTurningOrderPartyInfo({ party_id: partyId }));
      } else {
        dispatch(clearTurningOrderPartyInfo());
      }
    },
    [dispatch]
  );

  const handleSubmit = async (data: ITurningOrderFormInput) => {
    setIsSubmitting(true);
    try {
      await POST("/v1/admin/turning-orders", {
        party_id: data.party_id,
        date: moment(data.date).format("YYYY-MM-DD HH:mm:ss"),
        items: orderLinePayload(data.items, withRates),
      })
        .then((response: any) => {
          if (response.data.status === "success") {
            toast.success(response.data.message, {
              ...(toastStyles as any),
            });
            navigate(route.turningOrders);
          } else {
            toast.error(response.data.message, {
              ...(toastStyles as any),
            });
          }
        })
        .catch((error: any) => {
          toast.error(error.data.message, {
            ...(toastStyles as any),
          });
        });
    } catch (error) {
      toast.error("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.", {
        ...(toastStyles as any),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppLayout>
      <div className="mb-2 md:mb-0">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <div className="flex items-center mb-4 md:mb-6 mt-2">
        <h1 className={pageTitleClass}>નવો ટર્નિંગ ઓર્ડર ઉમેરો</h1>
      </div>

      <div className="flex flex-col gap-6">
        <TurningOrderForm
          partyOptions={partyOptions}
          partyInfo={partyInfo}
          partyInfoLoading={partyInfoLoading}
          onPartyChange={handlePartyChange}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          onCancel={() => navigate(route.turningOrders)}
          submitLabel="સાચવો"
          withRates={withRates}
        />
      </div>
    </AppLayout>
  );
};
export default TurningOrderCreatePage;
